import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PRIMARY } from "../../../utils/constansColors";
import { useParams } from "react-router-dom";
// import { Link } from "react-router-dom";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
  tableBody: {
    backgroundColor: "#FFFFFF",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    fontSize: "25px",
    borderRadius: 5,
  },
  tableHeader: {
    backgroundColor: "transparant",
    width: "100%",
    tableLayout: "fixed",
    marginTop: "10px",
    color: "#757575",
    fontWeight: 700,
  },
});

const columnData = [
  { no: 0, name: "No" },
  { no: 1, name: "Nama Daerah" },
  // { no: 2, name: "Nama Kab/Kota" },
  { no: 3, name: "Exco" },
  { no: 4, name: "Target" },
  { no: 5, name: "Capaian" },
	{ no: 6, name: "Hasil" },
];
export default function BasicTable(dataProps) {
  const classes = useStyles();

  const markers = []
  dataProps?.dataKabkot?.forEach((data)=>{
		markers.push({
			id_provinsi:data?.id_provinsi,
			nama_provinsi:data?.nama_provinsi,
			id_kabkot:data?.id_kabkot,
			nama_kab_kot:data?.nama_kab_kot,
			jumlah_anggota:data?.jumlah_anggota,
      jumlah_penduduk:data?.jumlah_penduduk,
			target_pb:data?.target_pb,
			target_kpu:data?.target_kpu,
			lat:data?.latitude,
			lon:data?.longitude,
			sk_pengurus:data?.info_dokumen?.dokumen_sk_pengurus,
			jumlah_pengurus:data?.jumlah_pengurus_kabkot,
      is_verified : data?.is_verified,
      is_locked : data?.is_locked,
		})
	})
	
	const persentase = (penyebut,pembagi) =>{
		let persen = 0
		if(pembagi !== 0){
			persen = ((penyebut/pembagi)*100).toFixed(0)
		}
		return persen
	}

  const hasil = (data) =>{
    let result = "TMS"
    // if(data.jumlah_pengurus > 0 && data?.sk_pengurus === 1 && data.jumlah_anggota >= data.target_pb){
    if(data.is_verified===1 && data.jumlah_anggota >= data.target_pb){
      result = "MS"
    }
    return result
  }
  // console.log(dataProps)

  return (
    <>
      <TableContainer>
        <Table
          sx={{ minWidth: 650 }}
          aria-label="simple table"
          className={classes.tableHeader}
        >
          <TableHead>
            <TableRow>
              {columnData.map((item, key) => {
                return (
                  <TableCell
                    key={key}
                    style={{
                      fontWeight: 700,
                      color: "#757575",
											textAlign:'center',
                      width: item.name === "No" ? "5%" : "",
                    }}
                  >
                    <div>{item.name}</div>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        </Table>
				<div style={{height:"400px", minWidth:'650px', overflowY:'auto', overflowX:'hidden'}}>
        {markers?.map((item, index) => {
          let number = index + 1;
          return (
            <Table
              sx={{ minWidth: 650 }}
              aria-label="simple table"
              className={classes.tableBody}
              key={"tab-" + index}
            >
              <TableBody>
                <TableRow key={item.id}>
                  <TableCell style={{ width: "5%" }}>{number}</TableCell>
                  <TableCell style={{ width: "" }}>
                    <span style={{ fontSize: "10px", color: "#757575" }}>Provinsi :</span> <br/>{item.nama_provinsi}<br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>Kab/Kota :</span> <br/>{item.nama_kab_kot}
									</TableCell>
                  <TableCell style={{ textAlign:'left' }}>
                    Keberadaan EXCO : <br/><span style={(item.is_verified === 1)? {color: "green", fontWeight:'bold'}:{color: "red", fontWeight:'bold'}}>
                      {(item.is_verified === 1)? "Ada" : "Tidak Ada"}
                    </span>
                    <br/>
                    Kelengkapan EXCO : <br/><span style={(item.sk_pengurus === 1 && item.jumlah_pengurus > 0)? {color: "green", fontWeight:'bold'}:{color: "red", fontWeight:'bold'}}>
                      {(item.sk_pengurus === 1 && item.jumlah_pengurus > 0)? "Lengkap" : "Belum Lengkap"}
                    </span>
                  </TableCell>
                  <TableCell style={{ width: "" }}>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Jumlah Penduduk :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.jumlah_penduduk)?.toLocaleString().replace(/,/g,".",)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Target Partai Buruh :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.target_pb)?.toLocaleString().replace(/,/g,".",)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Standar KPU :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.target_kpu)?.toLocaleString().replace(/,/g,".",)}
                    </span><br/>
                  </TableCell>
                  <TableCell style={{ textAlign:'left' }}>
										<span style={{ fontSize: "10px", color: "#757575" }}>
                      Jumlah Anggota :
                    </span><br/>
                    <span style={{ fontWeight: "bold" }}>
                      {parseInt(item?.jumlah_anggota)?.toLocaleString().replace(/,/g,".",)}
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Capaian Target PB:
                    </span><br/>
                    <span style={((item?.jumlah_anggota - item?.target_pb) > 0)?{ fontWeight: "bold", color:'green' }:{ fontWeight: "bold", color:'red' }}>
                      {persentase(item?.jumlah_anggota,parseInt(item?.target_pb))}% (
                        {((item?.jumlah_anggota - item?.target_pb) > 0)?"+":""}{(item?.jumlah_anggota - item?.target_pb)?.toLocaleString().replace(/,/g,".",)}
                      )
                    </span><br/>
                    <span style={{ fontSize: "10px", color: "#757575" }}>
                      Capaian Standar KPU :
                    </span><br/>
                    <span style={((item?.jumlah_anggota - item?.target_kpu) > 0)?{ fontWeight: "bold", color:'green' }:{ fontWeight: "bold", color:'red' }}>
                      {persentase(item?.jumlah_anggota,parseInt(item?.target_kpu))}% (
                        {((item?.jumlah_anggota - item?.target_kpu) > 0)?"+":""}{(item?.jumlah_anggota - item?.target_kpu)?.toLocaleString().replace(/,/g,".",)}
                      )
                    </span><br/>
                  </TableCell>
                  <TableCell style={(hasil(item)==="MS")?{ color: "white",textAlign:'center', fontWeight: "bold", backgroundColor:'green'}:{ color: "white", textAlign:'center', fontWeight: "bold", backgroundColor:'red'}}>
										{hasil(item)}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          );
        })}
				</div>
      </TableContainer>
    </>
  );
}
